module.exports = __webpack_public_path__ + "static/media/best_logo_.0eeaac9d.png";